import type { ReactNode } from 'react';

export function PageHeader({
  title,
  subtitle,
  actions,
  leading,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  /** Rendered at the far left of the header (e.g. a back arrow). */
  leading?: ReactNode;
}) {
  return (
    <header className="page-header">
      {leading && <div className="page-header__leading">{leading}</div>}
      <div>
        <h1 className="page-header__title">{title}</h1>
        {subtitle && <p className="page-header__subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="page-header__actions">{actions}</div>}
    </header>
  );
}
